// extracted by mini-css-extract-plugin
export var icon = "icons-module--icon--32b08";
export var iconText = "icons-module--iconText--7e132";